import React from 'react';

const LoadingState = () => (
    <div className="text-center py-5">
        <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2 mb-0 text-muted">Loading transactions...</p>
    </div>
);

export default LoadingState;
